<div class="password-recover-container">
    <div class="language-switcher-container">
        <on-language-switcher></on-language-switcher>
    </div>
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">{{ 'auth.forgot-password-title' | translate }}</h4>
            <div *ngIf="!isLoading">
                <p>
                    {{ 'auth.forgot-password-description' | translate }}
                </p>
                <p>
                    <input
                        class="form-control"
                        [(ngModel)]="email"
                        [placeholder]="'auth.email-placeholder' | translate"
                    />
                </p>
                <p class="text-center">
                    <button class="btn btn-primary" (click)="ForgotPassword()">
                        {{ 'auth.send' | translate }}
                    </button>
                </p>
            </div>
            <on-loading *ngIf="isLoading"></on-loading>
        </div>
    </div>
</div>
